import { GoogleMaps, withTheme } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';
import React from 'react';
import _ from '../../../../utils/LodashImports';
import { formatSlotsForMap } from '../utils';
import { DeliveryOptionsContentStyles } from './DeliveryOptionsContent.style';
import StoreListDetails from './StoresListDetails/StoreListDetails';

const DeliveryOptionsWithMaps = ({
  type,
  deviceType,
  theme,
  storeData,
  endpoints,
  labelsData,
  selectedStoreId,
  view,
  isMapView,
  isStockInStoreFlow,
  setSelectedStoreId,
  saveSelectedStoreOption,
  onCambiar,
  actions,
}) => {
  const mapRef = React.useRef(null);

  // const [showViewMore, setShowViewMore] = React.useState(false);
  // const [markerData, setMarkerData] = React.useState({
  //   lat: zoneConfig?.latitude,
  //   lng: zoneConfig?.longitude
  // });

  const markersData = formatSlotsForMap(type, storeData, selectedStoreId);
  const themedStoresListStyles = DeliveryOptionsContentStyles(theme);
  const saveButtonLabel = _.get(labelsData, 'SELECT_BUTTON', 'Seleccionar');
  const cancelButtonLabel = _.get(labelsData, 'CANCEL_BUTTON', 'Cancelar');
  // const viewMoreStoresLabel = _.get(
  //   labelsData,
  //   'VIEW_MORE_STORES',
  //   'Buscar en esta área'
  // );

  const isMobile = deviceType === 'mobile';

  const handleMarkerClick = (id) => {
    const item = document.getElementById(`testId-${id}`);
    if (item) {
      item.scrollIntoView({
        behavior: 'smooth',
        block: isMobile ? 'end' : 'center',
        inline: 'center',
      });
    }
    setSelectedStoreId((prev) => ({ ...prev, [type]: id }));
  };
  const saveSelectedDeliveryOption = () => {
    saveSelectedStoreOption();
    actions.close();
  };

  const closeModal = () => {
    actions.close();
    onCambiar();
  };

  return (
    <div className="container relative">
      {/* {deviceType !== 'desktop' && (
        <div
          role="button"
          id="screen3-zone-change"
          tabIndex={0}
          onKeyDown={noop}
          onClick={onCambiar}
          className={cx('zone-change', view === 'list' && 'list-view')}
        >
          <span>
            {capitalizeString(comunaName)}, {capitalizeString(regionName)}
          </span>
          <span className="arrow_down" />
        </div>
      )} */}

      {view === 'map' && (
        <div className="relative">
          <GoogleMaps
            mapRef={mapRef}
            markersData={markersData}
            isMarkerInteractive
            handleMarkerClick={handleMarkerClick}
            selectedPinId={selectedStoreId[type]}
            // handleDragEnd={handleDragEnd}
            containerStyle={{
              width: '100%',
              height: isMobile ? '100vh' : '270px',
              outline: 0,
            }}
            zoom={13}
            zoomControl={!isMobile}
            isSingleFingerScrollEnabled
          />
          {/* {showViewMore && (
            <button
              type="button"
              className="fetch-more-stores"
              onClick={() => {
                getPickupInStoreData({
                  ...zoneConfig,
                  latitude: markerData?.lat,
                  longitude: markerData?.lng
                });
              }}
            >
              {viewMoreStoresLabel}
            </button>
          )} */}
        </div>
      )}

      <StoreListDetails
        type={type}
        storeData={storeData}
        setSelectedStoreId={setSelectedStoreId}
        selectedStoreId={selectedStoreId}
        labelsData={labelsData}
        view={view}
        isMobile={isMobile}
        isStockInStoreFlow={isStockInStoreFlow}
        endpoints={endpoints}
        isMapView={isMapView}
        deviceType={deviceType}
        saveSelectedStoreOption={saveSelectedStoreOption}
      />
      <div className="flex-center">
        <button onClick={closeModal} type="button" className="cancel">
          {cancelButtonLabel}
        </button>
        <button
          disabled={!selectedStoreId[type]}
          onClick={saveSelectedDeliveryOption}
          type="button"
          className="save-zone"
        >
          {saveButtonLabel}
        </button>
      </div>
      <style jsx>{themedStoresListStyles}</style>
    </div>
  );
};

DeliveryOptionsWithMaps.propTypes = {
  type: PropTypes.string.isRequired,
  labelsData: PropTypes.object.isRequired,
  setSelectedStoreId: PropTypes.func.isRequired,
  selectedStoreId: PropTypes.any,
  theme: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  saveSelectedStoreOption: PropTypes.func.isRequired,
  onCambiar: PropTypes.func.isRequired,
  // getPickupInStoreData: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  storeData: PropTypes.object,
  isStockInStoreFlow: PropTypes.bool,
  endpoints: PropTypes.object.isRequired,
  view: PropTypes.string.isRequired,
  isMapView: PropTypes.bool.isRequired,
};

DeliveryOptionsWithMaps.defaultProps = {
  selectedStoreId: '',
  storeData: { StockInStore: [], PickupInStore: [] },
  isStockInStoreFlow: false,
};

export default withTheme(DeliveryOptionsWithMaps);
export { DeliveryOptionsWithMaps };
